export default "__VITE_ASSET__2efc8625__"